import type { SVGProps } from "react";
export interface PlaneVerticalIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PlaneVerticalIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PlaneVerticalIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M13.376 6.005c0-.5-.232-1.307-.632-2-.194-.337-.396-.589-.57-.742A.8.8 0 0 0 12 3.14a.8.8 0 0 0-.174.124c-.174.153-.376.405-.57.741-.4.694-.632 1.501-.632 2.001v2.75c0 .39-.202.753-.534.958l-5.55 3.413a.88.88 0 0 0-.416.746v.359l5.043-1.553a1.128 1.128 0 0 1 1.457 1.075v3.947c0 .298-.12.584-.33.795L8.88 19.91a.88.88 0 0 0-.256.62v.108l3.019-1.005.176-.043c.178-.029.363-.015.536.043l3.019 1.005v-.109a.88.88 0 0 0-.256-.62l-1.414-1.413c-.21-.21-.33-.497-.33-.795v-3.947a1.124 1.124 0 0 1 1.457-1.075l5.043 1.553v-.359a.88.88 0 0 0-.324-.681l-.092-.065-5.549-3.414a1.13 1.13 0 0 1-.534-.958zm2.25 2.121 5.012 3.085.169.112a3.13 3.13 0 0 1 1.318 2.55v1.206c0 1.024-.93 1.774-1.907 1.6l-.197-.048-4.396-1.353v1.957l1.084 1.084c.587.586.916 1.382.916 2.21v.977a1.625 1.625 0 0 1-2.139 1.541L12 21.884l-3.486 1.163a1.625 1.625 0 0 1-2.139-1.54v-.978c0-.828.33-1.624.916-2.21l1.084-1.084v-1.957L3.979 16.63a1.626 1.626 0 0 1-2.104-1.552v-1.206c0-1.085.563-2.093 1.487-2.662l5.013-3.085v-2.12c0-1 .394-2.194.931-3.125.275-.476.62-.944 1.033-1.307.402-.353.97-.694 1.661-.694l.253.015c.578.07 1.056.37 1.408.68.412.362.758.83 1.033 1.306.537.931.931 2.125.931 3.124z"
      />
    </svg>
  );
}
